var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotTakingNewClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "42px",
    viewBox: "0 0 32 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B84125EF-335A-41CB-A9D9-B3D361E57AB3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-T-P8-S4",
    transform: "translate(-867.000000, -238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(746.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(87.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-NotTakingNewClients",
    transform: "translate(34.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 42,
    rx: 2.625
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F07777",
    cx: 9.33333333,
    cy: 20.999985,
    rx: 4,
    ry: 3.93748498
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotTakingNewClients);
export default __webpack_public_path__ + "static/media/icon-NotTakingNewClients.67dae4974b5df8d5d49cc16e93d3c8e3.svg";
export { ForwardRef as ReactComponent };